import React, { useEffect, useState } from 'react'
import { useTheme } from '../../../../components/hooks/useTheme';
import { useLocation, useNavigate } from 'react-router-dom';
import { delete_VehicleMaintenanceRule, getVehicleMaintenanceRule, put_VehicleMaintenanceRule } from '../../../../services/VehicleMaintenanceRule';
import Select from 'react-select';
import { Button } from '@mui/material';
import colorConfigs from '../../../../configs/colorConfigs';
import PleaseWaitPopup from '../../../PleaseWaitPopup';
import useAuth from '../../../../components/hooks/useAuth';
import axios from 'axios';
import baseURL from '../../../../configs/api';
import { validateMin } from '../../../../utils/validateMin';
import useDelete from '../../../../components/hooks/useDelete';
import Cookies from 'js-cookie';
import useTenant from '../../../../components/hooks/useTenant';

const EditVehicleMaintenanceRule = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const idNumber = useLocation();
    const navigate = useNavigate();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [vehicleClassId, setVehicleClassId] = useState<string>("");
    const [maintenanceTypeId, setMaintenanceTypeId] = useState<string>("");
    const [odometer, setOdometer] = useState<number>(0);
    const [durations, setDurations] = useState<number>(0);
    const [vehicleClassOptions, setVehicleClassOptions] = useState([]);
    const [maintenanceTypeOptions, setMaintenanceTypeOptions] = useState([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true);

    useEffect(() => {
        axios
            .get(`${baseURL}vehicleClass`, {
                headers: {
                      'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                const data = response?.data;

                setVehicleClassOptions(() =>
                    data?.map((item: any) => {
                        return { value: item?.id, label: item?.name };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        axios
            .get(`${baseURL}maintenanceType/GetMaintenanceTypesWithActiveStatus/true`, {
                headers: {
                      'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                const data = response?.data;

                setMaintenanceTypeOptions(
                    data?.map((item: any) => {
                        return { value: item?.id, label: item?.maintenanceName };
                    })
                );
                handleTenantError(null);
            }).catch((error) => {
                setMaintenanceTypeOptions([]);
                handleTenantError(error);
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getVehicleMaintenanceRule(idNumber?.state, tenantId)
            .then((data) => {
                setVehicleClassId(data?.vehicleClassId);
                setMaintenanceTypeId(data?.maintenanceTypeId);
                setOdometer(data?.odometer);
                setDurations(data?.durations);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!pleaseWaitPopup) {
            setPleaseWaitPopup(true);

            await put_VehicleMaintenanceRule({
                id: idNumber?.state,
                vehicleClassId: vehicleClassId,
                maintenanceTypeId: maintenanceTypeId,
                odometer: odometer,
                durations: durations
            }, auth?.id, tenantId)
                .then(() => {
                    setPleaseWaitPopup(false);
                    navigate(-1);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }
    }

    const deleteVehicleMaintenanceRule = () => {
        setDeleteData({
            id: idNumber,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Vehicle Maintenance Rule?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);

                delete_VehicleMaintenanceRule(idNumber?.state, auth?.id, tenantId)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWaitPopup(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });

        setDeletePopup(true);
    };


    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Maintenance Rule</h2>
                                </div>

                                {
                                    disabled && (
                                        <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                            onClick={() => setDisabled(false)}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Class</label>
                                                    <Select
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                backgroundColor: themeStyles.topBar.bg,
                                                                color: themeStyles.topBar.textColor,
                                                                borderRadius: '8px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                                                "&: hover": {
                                                                    borderColor: "#167AC3",
                                                                }

                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "12px",
                                                                backgroundColor: themeStyles.topBar.bg,
                                                                color: themeStyles.topBar.textColor,
                                                            }),
                                                            option: (base, state) => {
                                                                const isSelected = state.isSelected;
                                                                const isFocused = state.isFocused;
                                                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                                                return {
                                                                    ...base,
                                                                    backgroundColor: isSelected
                                                                        ? selectedBg
                                                                        : isFocused
                                                                            ? hoverBg
                                                                            : "transparent",
                                                                    color: isSelected ? "#fff" : defaultTextColor,
                                                                    fontWeight: 600,
                                                                    ':active': {
                                                                        backgroundColor: isSelected ? selectedBg : hoverBg,
                                                                    },
                                                                };
                                                            },
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.topBar.textColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.topBar.textColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="vehicle"
                                                        value={vehicleClassOptions.find(
                                                            (item: any) => item.value === parseInt(vehicleClassId)
                                                        )}
                                                        onChange={(vehicle: any) =>
                                                            setVehicleClassId(vehicle ? vehicle.value : "")
                                                        }
                                                        options={vehicleClassOptions}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maintenance Type</label>
                                                    <Select
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                backgroundColor: themeStyles.topBar.bg,
                                                                color: themeStyles.topBar.textColor,
                                                                borderRadius: '8px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                                                "&: hover": {
                                                                    borderColor: "#167AC3",
                                                                }

                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "12px",
                                                                backgroundColor: themeStyles.topBar.bg,
                                                                color: themeStyles.topBar.textColor,
                                                            }),
                                                            option: (base, state) => {
                                                                const isSelected = state.isSelected;
                                                                const isFocused = state.isFocused;
                                                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                                                return {
                                                                    ...base,
                                                                    backgroundColor: isSelected
                                                                        ? selectedBg
                                                                        : isFocused
                                                                            ? hoverBg
                                                                            : "transparent",
                                                                    color: isSelected ? "#fff" : defaultTextColor,
                                                                    fontWeight: 600,
                                                                    ':active': {
                                                                        backgroundColor: isSelected ? selectedBg : hoverBg,
                                                                    },
                                                                };
                                                            },
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.topBar.textColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.topBar.textColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="maintenance"
                                                        value={maintenanceTypeOptions?.find(
                                                            (item: any) => item.value === parseInt(maintenanceTypeId)
                                                        )}
                                                        onChange={(maintenance: any) =>
                                                            setMaintenanceTypeId(maintenance ? maintenance?.value : "")
                                                        }
                                                        options={maintenanceTypeOptions}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer</label>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={odometer}
                                                        onChange={(e) => setOdometer(validateMin(e.target.value, 0))}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Durations (In Days)</label>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={durations}
                                                        onChange={(e) => setDurations(validateMin(e.target.value, 0))}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>                                     

                                        <div className="flex gap-4 mt-6">
                                            {
                                                !disabled && (
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg
                                                        }}
                                                        type="submit"
                                                    >
                                                        Save
                                                    </Button>
                                                )
                                            }

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteVehicleMaintenanceRule}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}

export default EditVehicleMaintenanceRule